module.exports = function getResource(label, vars = []) {
    const resources = {
        addGiftMessage: 'Add a Gift Message',
        new: 'New',
        giftMessageAdded: 'Gift Message Added',
        edit: 'Edit',
        remove: 'Remove'
    };

    return resources[label];
};
